import { render, staticRenderFns } from "./expressEmployeeDetail.vue?vue&type=template&id=03f97705&scoped=true"
import script from "./expressEmployeeDetail.vue?vue&type=script&lang=js"
export * from "./expressEmployeeDetail.vue?vue&type=script&lang=js"
import style0 from "./expressEmployeeDetail.vue?vue&type=style&index=0&id=03f97705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f97705",
  null
  
)

export default component.exports